import { API_BASE_URL, ACCESS_TOKEN } from "../constants";

function request(options) {
  const headers = new Headers({
    "Content-Type": "application/json",
    crossDomain: true,
  });


  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  } else {
    localStorage.clear();
    window.location.href = "/";
  }

  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);

  return fetch(options.url, options).then((response) => {
    if (!response.ok) {
      if (response.status === 403) {
        localStorage.clear();
        window.location.href = "/biz";
      }
      throw new Error("Something went wrong");
    }
    // Check if there's content to parse
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    }
    return response; // Return the response object for empty responses
  });
}


// auth controller apis
export function loginRequest(loginRequest) {
  return request({
    url: API_BASE_URL + "/auth/signin",
    method: "POST",
    body: JSON.stringify(loginRequest),
  });
}

export function logoutRequest(loginRequest) {
  return request({
    url: API_BASE_URL + "/api/auth/signout",
    method: "POST",
    body: JSON.stringify(loginRequest),
  });
}

export function sessionOutRequest(loginRequest) {
  return request({
    url: API_BASE_URL + "/auth/sessionout",
    method: "POST",
    body: JSON.stringify(loginRequest),
  });
}

export function addPayee(obj) {
  return request({
    url: API_BASE_URL + "/user/addPayee",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function sendData(obj) {
  return request({
    url: API_BASE_URL + "/sales/saveAll",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function salesRegister(obj) {
  return request({
    url: API_BASE_URL + "/sales/register",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function vehcilesRegupload(obj) {
  return request({
    url: API_BASE_URL + "/vehicles/upload",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function purchaseRegister(obj) {
  return request({
    url: API_BASE_URL + "/purchase/upload",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function secondarySalesRegister(obj) {
  return request({
    url: API_BASE_URL + "/sales/secondarySaleRegister",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function editCell(obj) {
  return request({
    url: API_BASE_URL + "/sales/editCell",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getBuzzList() {
  return request({
    url: API_BASE_URL + "/sales/transactions",
    method: "GET",
  });
}

export function getChequeSummary() {
  return request({
    url: API_BASE_URL + "/cheques/summary",
    method: "GET",
  });
}

export function callChequeDeposit(obj) {
  return request({
    url: API_BASE_URL + "/cheques/deposit",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getTrans(obj) {
  return request({
    url: API_BASE_URL + "/sales/transactions",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getTransItems(obj) {
  return request({
    url: API_BASE_URL + "/sales/saleDetails",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function updateUnitRowApi(obj) {
  return request({
    url: API_BASE_URL + "/sales/updateUnitRow",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function multiDeleteApi(obj) {
  return request({
    url: API_BASE_URL + "/sales/multiDelete",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function multiDeleteInvoices(obj) {
  return request({
    url: API_BASE_URL + "/sales/multiDeleteInvoices",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function multiActionBy(obj) {
  return request({
    url: API_BASE_URL + "/sales/multiActionBy",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function updateAndRemove(obj) {
  return request({
    url: API_BASE_URL + "/sales/updateAndRemove",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function updateBeatName(obj) {
  return request({
    url: API_BASE_URL + "/sales/updateBeatName",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function canceLInvoice(obj) {
  return request({
    url: API_BASE_URL + "/sales/cancel",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getPaymentTypes() {
  return request({
    url: API_BASE_URL + "/config/paymentType",
    method: "GET",
  });
}
export function validateUpdateReceivePayment(obj) {
  return request({
    url: API_BASE_URL + "/payment/validate",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function updateRecivePaymnt(obj) {
  return request({
    url: API_BASE_URL + "/payment/create",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getPaymntGistory(obj) {
  return request({
    url: API_BASE_URL + "/payment/history",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function addChequeBounceCharges(obj) {
  return request({
    url: API_BASE_URL + "/payment/penality",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getReceivePayment(obj) {
  return request({
    url: API_BASE_URL + "/payment/fetchPaymentsForInvoice",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getPartyHistoryByHULCode(id) {
  return request({
    url: API_BASE_URL + "/sales/summary?hulCode=" + id,
    method: "GET",
  });
}

export function getInvoiceCopy(obj) {
  return request({
    url: API_BASE_URL + "/invoice /download",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getBankList() {
  return request({
    url: API_BASE_URL + "/bank/balances",
    method: "GET",
  });
}

export function getSelectedBankTrans(obj) {
  return request({
    url: API_BASE_URL + "/bank/audit",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function PosttransfferPayment(obj) {
  return request({
    url: API_BASE_URL + "/bank/transfer",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function PostPaymentDue(obj) {
  return request({
    url: API_BASE_URL + "/payment/paymentDues",
    method: "POST",
    body: JSON.stringify(obj),
  });
}



// new backend endpoint for dues verification by orders
export function verifyDuesByOrders(obj) {
  return request({
    url: API_BASE_URL + "/payment/verifyDuesByOrders", // adjust to actual API path
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function uploadCashDetails(obj) {
  return request({
    url: API_BASE_URL + "/payment/uploadCashDetails", // adjust to actual API path
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getUploadCashDetailsByDateRange(obj) {
  return request({
    url: API_BASE_URL + "/payment/getUploadCashDetailsByDateRange",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function GetSalesByPerson(obj) {
  return request({
    url: API_BASE_URL + "/payment/paymentDuesBySalesPerson",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getDashBoardData(obj) {
  return request({
    url: API_BASE_URL + "/api/dashboard",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

//reports
export function getGSTDetails(obj) {
  return request({
    url: API_BASE_URL + "/reports/gst",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getDayBookData(obj) {
  return request({
    url: API_BASE_URL + "/reports/daybook",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getLoadingSheet(obj) {
  return request({
    url: API_BASE_URL + "/sales/loadingsheet",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

// expenses api's

export function getExpenseData(obj) {
  return request({
    url: API_BASE_URL + "/exp/list",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function saveBillerORcate(obj) {
  return request({
    url: API_BASE_URL + "/exp/saveBillOrCate",
    method: "POST",
    body: JSON.stringify(obj),
  });
}


export function getAllExpAptions() {
  return request({
    url: API_BASE_URL + "/exp/expAptions",
    method: "GET",
  });
}

export function saveExpense(obj) {

  return request({
    url: API_BASE_URL + "/exp/save",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
//sale inovice 

export function getItemsdData() {
  return request({
    url: API_BASE_URL + "/items/",
    method: "GET",
    //body: JSON.stringify(obj),
  });
}

export function saveInvoiceData(obj) {

  return request({
    url: API_BASE_URL + "/invoice/save",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function getPartyDetails() {
  return request({
    url: API_BASE_URL + "/partyDetails",
    method: "GET",
    // body: JSON.stringify(obj),
  });
}

// Fetch next invoice number from backend
export function getNextInvoiceNumber() {
  return request({
    url: API_BASE_URL + "/invoice/nextInvoiceNumber",
    method: "GET",
  });
}

//stock details
export function addNewItem(obj) {

  return request({
    url: API_BASE_URL + "/item/save",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

// add party details
export function addNewParty(obj) {

  return request({
    url: API_BASE_URL + "/party/save",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function editParyDetails(obj) {

  return request({
    url: API_BASE_URL + "/party/update",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function deleteParyDetails(obj) {

  return request({
    url: API_BASE_URL + "/party/delete",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function PartyPaymentDue(obj) {
  return request({
    url: API_BASE_URL + "/invoice/party/paymentDues",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function GetPartyDueDetails(obj) {
  return request({
    url: API_BASE_URL + "/invoice/party/paymentDueDetails",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function PostPaymentDueByBeatwise(obj) {
  return request({
    url: API_BASE_URL + "/payment/paymentDues/beatwise",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function GetSalesByBeat(obj) {
  return request({
    url: API_BASE_URL + "/payment/paymentDuesByBeat",
    method: "POST",
    body: JSON.stringify(obj),
  });
}



export function saveUploadInvoiceItems(obj) {
  return request({
    url: API_BASE_URL + "/invoiceRead/upload/save",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function mstrDataPartyReg(obj) {
  return request({
    url: API_BASE_URL + "/masterData/partyUpload",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function mstrDataRateReg(obj) {
  return request({
    url: API_BASE_URL + "/masterData/rateUpload",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

//getaccessKey

export function getAccessKeyForpayment(obj) {
  return request({
    url: API_BASE_URL + "/payment/initiate",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getAssetsAndLiabilities() {
  return request({
    url: API_BASE_URL + "/api/financial/records",
    method: "GET",
  });
}

export function getCategoriesListForFin() {
  return request({
    url: API_BASE_URL + "/api/financial/category",
    method: "GET",
  });
}

export function deleteFinancialRecord(recordId) {
  return request({
    url: API_BASE_URL + "/api/financial/records/" + recordId,
    method: "DELETE",
  });
}

export function saveCategoryFin(obj) {
  return request({
    url: API_BASE_URL + "/api/financial/category",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export async function createFinancialRecord(formData) {
  const options = {
    url: API_BASE_URL + "/api/financial/records",
    method: "POST",
    headers: new Headers(),  // Let browser set the Content-Type for FormData
    body: formData  // Don't stringify FormData
  };

  if (localStorage.getItem(ACCESS_TOKEN)) {
    options.headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }

  const response = await fetch(options.url, options);
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Failed to create record");
  }
}

export async function updateFinancialRecord(recordId, formData) {
  const options = {
    url: API_BASE_URL + "/api/financial/records/" + recordId,
    method: "POST",
    headers: new Headers(),  // Let browser set the Content-Type for FormData
    body: formData  // Don't stringify FormData
  };

  if (localStorage.getItem(ACCESS_TOKEN)) {
    options.headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }

  const response = await fetch(options.url, options);
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Failed to create record");
  }
}

//Document center apis
export function getAllDocumentList() {
  return request({
    url: API_BASE_URL + "/api/document-center",
    method: "GET",
  });
}



export async function uploadDocument(formData) {
  const options = {
    url: API_BASE_URL + "/api/document-center",
    method: "POST",
    headers: new Headers(),  // Let browser set the Content-Type for FormData
    body: formData  // Don't stringify FormData
  };

  if (localStorage.getItem(ACCESS_TOKEN)) {
    options.headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }

  const response = await fetch(options.url, options);
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Failed to upload document");
  }
}

export function deleteDocumentRecord(recordId) {
  return request({
    url: API_BASE_URL + "/api/document-center/" + recordId,
    method: "DELETE",
  });
}
export function downloadDocument(recordId, fileName) {
  const encoded = encodeURIComponent(fileName || '');
  return request({
    url: API_BASE_URL + "/api/document-center/download/" + recordId + "/" + encoded,
    method: "GET",
  });
}

// investors api's
export function getInvestorsSummary() {
  return request({
    url: API_BASE_URL + "/api/investor-transactions/summary",
    method: "GET",
  });
}
export function getInvestorsMetadata() {
  return request({
    url: API_BASE_URL + "/api/investors-config",
    method: "GET",
  });
}
export function saveInvestorTransaction(obj) {
  return request({
    url: API_BASE_URL + "/api/investor-transactions",
    method: "POST",
    body: JSON.stringify(obj)
  });
}

// Add new investor config (investor, category, or transaction type)
export function saveInvestorConfig(obj) {
  return request({
    url: API_BASE_URL + "/api/investors-config",
    method: "POST",
    body: JSON.stringify(obj)
  });
}

// fetch investor transactions by investor name
export function getInvestorTransactionsByName(name) {
  return request({
    url: API_BASE_URL + "/api/investor-transactions?investorName=" + encodeURIComponent(name),
    method: "GET",
  });
}

// fetch investor transactions for a date range
export function getInvestorTransactionsRange(name, from, to) {
  const params = `investorName=${encodeURIComponent(name)}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
  return request({
    url: API_BASE_URL + "/api/investor-transactions/range?" + params,
    method: "GET",
  });
}

// recruring setup api
export function getRecurrSetupData() {
  return request({
    url: API_BASE_URL + "/api/recurring",
    method: "GET",
  });
}

export function getRecurrSetupDataOptions() {

  return request({
    url: API_BASE_URL + "/api/recurring/options",
    method: "GET",
  });
}

export function saveRecurrSetupData(obj) {
  return request({
    url: API_BASE_URL + "/api/recurring",
    method: "POST",
    body: JSON.stringify(obj),
  });
}
export function deleteRecurrSetupData(recordId) {
  return request({
    url: API_BASE_URL + "/api/recurring/" + recordId,
    method: "DELETE",
  });
}

// Email sync center APIs
export function emailLoadReq() {
  return request({
    url: API_BASE_URL + "/api/emails/emailLoadreq",
    method: "GET",
  });
}

export function fetchEmails(obj) {
  return request({
    url: API_BASE_URL + "/api/emails/fetch",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function getEmailsByDateRange(obj) {
  return request({
    url: API_BASE_URL + "/api/emails/by-date-range",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function extractEmailDetails(obj) {
  return request({
    url: API_BASE_URL + "/api/emails/extractDetails",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function extractEmailDetailsByStatus() {
  return request({
    url: API_BASE_URL + "/api/emails/extractDetailsByStatus",
    method: "GET",
  });
}

export function verifyEmailDetails(obj) {
  return request({
    url: API_BASE_URL + "/api/emails/verify",
    method: "POST",
    body: JSON.stringify(obj),
  });
}

export function processEmailDetails(obj) {
  return request({
    url: API_BASE_URL + "/api/emails/process",
    method: "POST",
    body: JSON.stringify(obj),
  });
}



// WEBPACK FOOTER //
// ./src/util/APIUtils.js